import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapFilterPageComponent from './mapFilterPage.component';

let mapFilterPageModule = angular.module('mapFilterPage', [
  uiRouter
])

.component('mapFilterPage', mapFilterPageComponent)

.name;

export default mapFilterPageModule;
